/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Component, Input } from '@angular/core';
import { LicenseDTO } from '../../models/license-dto';

declare var $: any;

@Component({
  selector: 'app-view-license-dialog',
  templateUrl: './view-license-dialog.component.html'
})
export class ViewLicenseDialogComponent {

  @Input()
  mLicense: LicenseDTO;



  public showDialog(): void {
    $("#viewLicenseModal").modal("show");
  }

  public hideDialog(): void {
    $("#viewLicenseModal").modal("hide");
  }

  getEntityTypeLimits(): EntityTypeLimitUI[] {
    const rv: EntityTypeLimitUI[] = [];
    if (this.mLicense != null && this.mLicense.license_details != null && this.mLicense.license_details.licensed_entity_type_limits != null) {
      for (const entityType of Object.keys(this.mLicense.license_details.licensed_entity_type_limits)) {
        const ui = new EntityTypeLimitUI();
        ui.mEntityType = entityType;
        ui.mLimit = this.mLicense.license_details.licensed_entity_type_limits[entityType];
        rv.push(ui);
      }
    }
    return rv;
  }

}

class EntityTypeLimitUI {
  mEntityType: string;
  mLimit: number;
}
